
let nstcRouters = [
    {
        title: '藥檢管理系統',
        icon: { icon: 'tabler-box' },
        children: [],
    }
]

const modulesFiles = import.meta.glob('./nstc/rtp/*.ts', { eager: true })

Object.keys(modulesFiles).forEach(key => {
const module = modulesFiles[key]
nstcRouters[0].children.push(module.default)
})

export default nstcRouters
